import React from "react";
import { Card, Spinner } from "react-bootstrap";

const PieChartSkeleton: React.FC = () => {
    return (
        <Card className="p-3 bg-white rounded shadow-sm">
            <Card.Header className="bg-white border-0">
                <h5 className="text-center m-0">Loading Chart...</h5>
            </Card.Header>
            <Card.Body className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
                <Spinner animation="border" variant="primary" />
            </Card.Body>
        </Card>
    );
};

export default PieChartSkeleton;